import React from 'react';

const VehicleInput = ({ value, onChange, placeholder, required, dataTestId, disabled }) => {
  const handleChange = (e) => {
    let input = e.target.value;
    // Remove all spaces, special characters except letters and numbers
    input = input.replace(/[^a-zA-Z0-9]/g, '');
    // Convert to uppercase
    input = input.toUpperCase();
    onChange(input);
  };

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      data-testid={dataTestId}
      disabled={disabled}
      className="w-full bg-black/50 border border-white/20 focus:border-[#FF3B30] focus:ring-1 focus:ring-[#FF3B30] rounded-lg p-3 text-white outline-none transition-all disabled:opacity-50 uppercase"
      maxLength={15}
    />
  );
};

export default VehicleInput;